import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "version" }

import { computed, onMounted, ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { infoToast } from '@/utils/toastUtils';
  import { useDiagStore } from '@/store/diagStore';
  import { useConfigStore } from '@/store/configStore';

  // Define state
  
export default /*@__PURE__*/_defineComponent({
  __name: 'VersionInfo',
  setup(__props) {

  const dialog = ref(false);
  const diagStore = useDiagStore();
  const configStore = useConfigStore();

  const { t } = useI18n();

  const appVersion = computed(() => diagStore.getAppVersion);
  const configData = computed(() => configStore.configData);

  onMounted(async () => {
    await diagStore.fetchDiagInfo();
    await configStore.fetchConfigData();
  });

  // Methods
  const openDialog = () => {
    if (appVersion.value !== null) {
      dialog.value = true;
    }
  };

  const copyToClip = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      infoToast(t('info.copied', { text }));
    });
  };

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (appVersion.value !== null)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            variant: "plain",
            class: "cr-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openDialog()))
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode(" © asfal s.r.o. ", -1)
            ]))]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_btn, {
            key: 1,
            variant: "plain",
            class: "cr-btn",
            href: "https://asfal.eu",
            target: "_blank"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" © asfal s.r.o. ", -1)
            ]))]),
            _: 1
          }))
    ]),
    (appVersion.value !== null)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 0,
          modelValue: dialog.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialog).value = $event)),
          class: "versionDialog",
          persistent: "",
          "max-width": "800"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              actions: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (dialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode(" OK ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('info.dialogTitle')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('info.copyright')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "8"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              variant: "text",
                              href: "https://asfal.eu",
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                _createTextVNode(" © asfal s.r.o. ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_divider, { class: "mt-4 mb-4" }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "12"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("strong", null, _toDisplayString(_unref(t)('info.backend.title')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('info.backend.version')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "8"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(appVersion.value.version), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('info.backend.commitHash')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "8"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              variant: "text",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (copyToClip(appVersion.value.gitCommit)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                    _createTextVNode("mdi-content-copy", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createTextVNode(" " + _toDisplayString(appVersion.value.gitCommit), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('info.backend.buildTime')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "8"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(appVersion.value.buildTime), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (
            configData.value &&
            (configData.value.quarkusApplicationVersion ||
              configData.value.buildTimestamp ||
              configData.value.buildGitCommit)
          )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_v_divider, { class: "mt-4 mb-4" }),
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("strong", null, _toDisplayString(_unref(t)('info.frontend.title')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (configData.value && configData.value.quarkusApplicationVersion)
                            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('info.frontend.quarkusApplicationVersion')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "8"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(configData.value.quarkusApplicationVersion), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (configData.value && configData.value.buildGitCommit)
                            ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('info.frontend.buildGitCommit')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "8"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        variant: "text",
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => (copyToClip(configData.value.buildGitCommit)))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, null, {
                                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                              _createTextVNode("mdi-content-copy", -1)
                                            ]))]),
                                            _: 1
                                          }),
                                          _createTextVNode(" " + _toDisplayString(configData.value.buildGitCommit), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (configData.value && configData.value.buildTimestamp)
                            ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('info.frontend.buildTimestamp')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "8"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(configData.value.buildTimestamp), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})